



































































































































































import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import { NotificationEventBus } from '@/EventBus';
import Viewpoints, { ChoiceFactorsScoreChanges } from "@/store/modules/Viewpoints";
import Decisions from "@/store/modules/Decisions";
import Scoring from "@/store/modules/Scoring";
import Choices from "@/store/modules/Choices";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import FactorScoringDefinitionCreator from "@/components/scoring-definition/FactorScoringDefinitionCreator.vue";
import ViewpointFactorScore from "@/components/scoring-input/ViewpointFactorScore.vue";
import FactorValueDisplay from "@/components/common/FactorValueDisplay.vue";
import ChoiceFactorInputMenu from "@/components/choice-input/ChoiceFactorInputMenu.vue";
import FactorScoringDefinitionButtonTrigger
    from "@/components/scoring-definition/FactorScoringDefinitionButtonTrigger.vue";
import ScoreSliderKey from "@/components/scoring-input/ScoreSliderKey.vue";
import ScoringKeys from "@/store/modules/ScoringKeys";
import ViewpointFactorScoreGrowingTable from "@/components/scoring-input/ViewpointFactorScoreGrowingTable.vue";
import { Factor, FactorGroup } from "@/api/model/FactorResource";
import Modelling from "@/store/modules/Modelling";
import { Viewpoint } from "@/api/model/Viewpoint";
import Users from '@/store/modules/Users';
import CardTitle from '@/components/common/CardTitle.vue';


const modellingModule = getModule(Modelling);
const viewpointsModule = getModule(Viewpoints)
const decisionsModule = getModule(Decisions);
const scoringModule = getModule(Scoring);
const choicesModule = getModule(Choices);
const workspaceOptionsModule = getModule(WorkspaceOptions)
const scoringKeysModule = getModule(ScoringKeys)
const userModule = getModule(Users)
@Component({
    components: {
        CardTitle,
        TableRowViewpointFactorScore: ViewpointFactorScoreGrowingTable,
        ScoringSliderSelect: ScoreSliderKey,
        ButtonScoringDefinitionTrigger: FactorScoringDefinitionButtonTrigger,
        MenuFactorValueEditor: ChoiceFactorInputMenu,
        FactorValueDisplay,
        ViewpointFactorScore,
        FactorScoringDefinitionCreator
    }
})
export default class TableSingleScoreInput extends Vue {

    @Prop({ default: 0, type: Number })
    factorLevel!: number;

    @Prop()
    tableFactorGroup!: FactorGroup

    @Prop({default: () => true, type: Boolean})
    groupSummary: boolean;

    @Prop()
    sortedViewpoints: Viewpoint[];

    @Prop({ default: false, type: Boolean })
    disableInputs!: boolean;

    private selectedFactorId: string | null = null;
    private deleteRowLoading: boolean = false;
    private deleteRowIndex: number = null;

    private showDeleteRowDialog: boolean = false;

    get viewpointFirstCol() {
        return workspaceOptionsModule.viewpointFirstCol - (this.elementDepth * 8);
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get columnWidths() {
        if (Object.keys(workspaceOptionsModule.viewpointsColumnWidth).length === 0) {
            workspaceOptionsModule.changeViewpointColumnWidth(150);
        }
        return workspaceOptionsModule.viewpointsColumnWidth;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get viewpointScoringKeyDefinitions() {
        console.log("viewpointscoreergrow")
        return scoringKeysModule.viewpointScoringKeyDefinitions
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    }

    get tableChildren() {
        return this.tableFactorGroup.childrenIds.map(cId => this.factorResources[cId])
    }

    get scoredChoices() {
        return scoringModule.viewpointScores;
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get contributingFactorResources() {
        return viewpointsModule.contributingFactorResources;
    }

    get maxNumberRows() {
        let dataLengths = this.tableChildren
            .map((tc: any) => this.selectedChoice[tc.dataField])
            .filter((data: any) => data != null && Array.isArray(data))
            .map((data: any[]) => data.length)
        return Math.max(0, ...dataLengths)
    }

    get factorListTree(){
        return modellingModule.factorListTree
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get currentUserId() {
        if(userModule.currentUserProfile){
            return userModule.currentUserProfile.userId;
        }else{
            return null;
        }
    }

    get editContent() {
        return workspaceOptionsModule.editContent;
    }

    get editableValue() {
        if (this.editContent) {
            return ['ADMIN', 'OWNER'].includes(this.currentUserPermission) && this.editPermissions;
        }
        else {
            return false;
        }
    }

    get currentUserPermission() {
        if(decisionsModule.selectedDecisionUsers && this.currentUserId){
            return decisionsModule.selectedDecisionUsers[this.currentUserId].permissionAccess
        }else{
            return null;
        }
    }

    get editPermissions() {
        return getModule(Choices).checkChoiceEditPermissions
    }

    get tableCellPadding() {
        return '5px 10px;';
    }

    get elementDepth() {
        return this.factorLevel - 2
    }

    get showFactorData() {
        return workspaceOptionsModule.showFactorData;
    }

    private isFactorVisible(resourceId: string) {
        if(this.showNonListFactors || !this.isFactorListActive) {
            // return  this.contributingVisibility || (!this.contributingVisibility  && (!this.contributingFactorResources[resourceId] || this.contributingFactorResources[resourceId].numWeightingDots > 0))
            return true;
        }
        else {
            if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                    return true
            } else
                return false;
        }
    }

    private getWidth(type: string) {
        switch (type) {
            case 'TEXT':
                return 160;
            case 'FILE':
            case 'CATEGORICAL':
                return 140;
        }
        return 120;
    }

    private viewpointFactorResource(viewpointId: string) {
        if (viewpointId) {
            return (
                viewpointsModule.viewpointFactorResources[viewpointId] || {}
            );
        }
        return {};
    }

    private getColumnRuleExists(viewpointId: string) {
        const colsWithRule = this.tableChildren.filter((factor: Factor) => this.checkFactorForRules(factor.id, viewpointId));
        if (colsWithRule.length > 0) {
            return true;
        } else
            return false;
    }

    private checkFactorForRules(factorId: string, viewpointId: string) {
        if (this.viewpointFactorResource(viewpointId)[factorId] && this.viewpointFactorResource(viewpointId)[factorId].scoringDefinition) {
            if (this.viewpointFactorResource(viewpointId)[factorId].scoringDefinition.type != "MANUAL") {
                return true;
            }
            else {
                return false;
            }
        } else {
            if ((this.factors[factorId] as Factor).scoringDefinition != null) {
                if ((this.factors[factorId] as Factor).scoringDefinition.type === "MANUAL" ) {
                    return false;
                }
                else {
                    return true;
                }
            }
        }
    }

    private async deleteRowViewpointScore(index: number) {
        let allViewpointScores = scoringModule.viewpointScores;
        for (const vp of this.sortedViewpoints) {
            let choiceFactors = allViewpointScores[vp.viewpointId].choiceScores[this.selectedChoice.id].choiceFactorScores
            let newScores = this.tableFactorGroup.childrenIds
                .map(id => {   
                    return {
                        factorId: id,
                        scores: [...choiceFactors[id].scores.slice(0, index - 1), ...choiceFactors[id].scores.slice(index)]
                    }
                })

            let payload: ChoiceFactorsScoreChanges = {
                viewpointId: vp.viewpointId,
                choiceId: this.selectedChoice.id,
                scores: newScores
            };

            NotificationEventBus.emitProcessingMessage();
            try {
                await viewpointsModule.putViewpointChoiceFactorScores(payload)
                NotificationEventBus.emitSuccessMessage();
            } catch (e) {
                NotificationEventBus.emitFailedMessage(e);
            }
        }

        return;
    }

    private toggleDeleteDialog( index: number ) {
        this.deleteRowIndex = index;
        this.showDeleteRowDialog = !this.showDeleteRowDialog;
    }

    private async deleteRow(index: number) {
        this.deleteRowLoading = true;
        this.toggleDeleteDialog(null);

        let updatedChoiceFactors = [];
        for (const child of this.tableChildren) {
            updatedChoiceFactors[child.dataField] = [...this.selectedChoice[child.dataField].slice(0, index - 1), ...this.selectedChoice[child.dataField].slice(index)]
        }

        NotificationEventBus.emitProcessingMessage();
        try {
            await getModule(Choices).updateChoice({choice: Object.assign(this.selectedChoice, updatedChoiceFactors), refreshScoring: true });
            NotificationEventBus.emitSuccessMessage();
            scoringModule.refreshScoring();
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e);
        }

        this.deleteRowLoading = false;
    }
    
    private async addRow() {

        let updatedChoiceFactors = [];
        for (const child of this.tableChildren) {
            updatedChoiceFactors[child.dataField] = this.selectedChoice[child.dataField] ? [...this.selectedChoice[child.dataField], null] : [null] ;
        }

        NotificationEventBus.emitProcessingMessage();
        try {
            await getModule(Choices).updateChoice({choice: Object.assign(this.selectedChoice, updatedChoiceFactors), refreshScoring: true });
            NotificationEventBus.emitSuccessMessage();
            scoringModule.refreshScoring();
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e);
        }
        this.deleteRowLoading = false;
    }

    private async updateChoiceData(value: any, resourceId, tableIndex: number) {
        let choiceValues = this.selectedChoice[resourceId];
        if ( choiceValues[tableIndex] === value ) return;
        
        choiceValues[tableIndex] = value; 
        
        NotificationEventBus.emitProcessingMessage();
        try {
            await getModule(Choices).updateChoiceField({
                choiceId: this.selectedChoice.id,
                value: choiceValues,
                factorResourceId: resourceId,
                refreshScoring: false,
            });
            NotificationEventBus.emitSuccessMessage();
            scoringModule.refreshScoring();
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e);
        }
    }

}
